// Global constants for the frontend application

// Add any shared constants here, e.g., API endpoints, magic numbers, etc.

export const APP_NAME = 'Polymyth';

/**
 * How many classes a player can actually create a character as.
 *
 * The backend decides it: `SUPPORTED_PC_CLASSES` in
 * `backend/lobby-server/src/services/pc_template_loader.rs` lists 11, with Rogue
 * excluded for the Goldvale MVP. This is the frontend's single copy of that
 * number, and every piece of copy that quotes it imports from here.
 *
 * It exists because the number was written out by hand in two places, one page
 * was corrected to 11, the other was missed, and the landing page went on
 * advertising 12 to every visitor while /about said 11.
 */
export const PLAYABLE_CLASS_COUNT = 11;

export const DISCORD_INVITE_URL = 'https://discord.gg/FP25atX6zM';
export const X_URL = 'https://x.com/avive';
export const BLUESKY_URL = 'https://bsky.app/profile/tavianportal.bsky.social';
export const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61592272011285';

// Promo video (YouTube id) shown on the signup page + landing "Free to Start"
// section. Empty string hides the player everywhere (never a broken embed).
export const PROMO_VIDEO_ID = 'WFOi7bnxYhw';
/** Unlisted "Zero to Adventure in 60 seconds" gameplay playthrough (homepage hero). */
export const GAMEPLAY_VIDEO_ID = '3yMGC3Y25Zk';

// Local development only (excludes staging deploys which also have DEV=true)
export const IS_DEV = import.meta.env.DEV && import.meta.env.VITE_ENV !== 'staging';

// Test credentials — only in local dev (never staging/production)
export const DEV_TEST_EMAIL = IS_DEV
  ? import.meta.env.VITE_DEV_TEST_EMAIL || 'new-test-user-dec9@danda.dev'
  : '';
export const DEV_TEST_PASSWORD = IS_DEV
  ? import.meta.env.VITE_DEV_TEST_PASSWORD || 'E2E-Test-Pass-2025!'
  : '';

// Pre-populate login form with test credentials in local development only
export const AUTH_FORM_DEFAULTS = {
  email: IS_DEV ? DEV_TEST_EMAIL : '',
  password: IS_DEV ? DEV_TEST_PASSWORD : '',
};
